// ContextMenuController.js
// Ref: https://github.com/dgoguerra/bootstrap-menu

import $ from 'jquery';
import {Model} from 'backbone';

import BaseController       from 'BaseController';
import BootstrapMenu        from 'bootstrap-menu';
import constants            from 'Constants';
import listService          from 'ListService';
import crudController       from 'CrudController';
import alignmentController  from 'AlignmentController';
import groupController      from 'GroupController';
import ShowBehaviorListModalView from 'common-views/ShowBehaviorListModalView';


//======================================================================================
// Client of bootstrap-menu context menu.
// Ref:
// https://github.com/dgoguerra/bootstrap-menu
//======================================================================================
class ContextMenuController extends BaseController {

    constructor() {
        super();

        this._menu = new BootstrapMenu(constants.CLASS_HAS_MENU, {

            fetchElementData: function ($elem) {
                return $elem;
            },

            //_actionSelectEvent: 'mousedown',

            //menuEvent: 'hover',

            /* Group actions by their id to create separators between
             * them in the context menu. Actions not appearing in a
             * group  appear in a default group. */
            actionsGroups: [
                ['cutItem', 'copyItem', 'pasteItem', 'deleteItem'],
                ['alignTop', 'alignRight', 'alignBottom', 'alignLeft'],
                ['sameWidth', 'sameHeight'],
                ['evenlySpaceAcross', 'evenlySpaceDown'],
                ['moveToTopLayer', 'moveToBottomLayer', 'groupToggle'],
                ['showAvailableBehaviors']
            ],

            actions: {
                cutItem: {
                    name: '<span class="context-item">Cut item</span><span class="keyboard-shortcut">Ctrl+x</span>',
                    onClick: function () {
                        crudController.cutSelected();
                    },
                    isEnabled: function () {
                        return (listService.selectedCount > 0 );
                    }
                },
                copyItem: {
                    name: '<span class="context-item">Copy item</span><span class="keyboard-shortcut">Ctrl+c</span>',
                    onClick: function () {
                        crudController.copySelected();
                    },
                    isEnabled: function () {                         
                        return (listService.selectedCount > 0);
                    }
                },
                pasteItem: {
                    name: '<span class="context-item">Paste item</span><span class="keyboard-shortcut">Ctrl+v</span>',
                    onClick: function () {
                        crudController.pasteSelected();
                    },
                    isEnabled: function () {
                        return listService.clipboardCount > 0;
                    }
                },
                deleteItem: {
                    name: 'Delete item',
                    onClick: function () {
                        console.log('delete');
                        if (listService.selectedCount) {
                            crudController.deleteSelected();
                        } else {
                            window.setTimeout(() => crudController.deletePage(), 0);

                        }
                    },
                    isEnabled: function () {
                        return true; //  If none selected, it is a page delte. ///listService.selectedCount > 0;
                    }
                },

                alignTop: {
                    name: 'Align top',
                    onClick: function () {
                        alignmentController.alignTop(listService.selected);
                    },
                    isEnabled: function () {
                        return listService.selectedCount > 1;
                    }
                },
                alignRight: {
                    name: 'Align right',
                    onClick: function () {
                        alignmentController.alignRight(listService.selected);
                    },
                    isEnabled: function () {
                        return listService.selectedCount > 1;
                    }
                },
                alignBottom: {
                    name: 'Align bottom',
                    onClick: function () {
                        alignmentController.alignBottom(listService.selected);
                    },
                    isEnabled: function () {
                        return listService.selectedCount > 1;
                    }
                },
                alignLeft: {
                    name: 'Align left',
                    onClick: function () {
                        alignmentController.alignLeft(listService.selected);
                    },
                    isEnabled: function () {
                        return listService.selectedCount > 1;
                    }
                },

                sameWidth: {
                    name: 'Make same width',
                    onClick: function () {
                        alignmentController.makeSameWidth(listService.selected);
                    },
                    isEnabled: function () {
                        return listService.selectedCount > 1;
                    }
                },
                sameHeight: {
                    name: 'Make same height',
                    onClick: function () {
                        alignmentController.makeSameHeight(listService.selected);
                    },
                    isEnabled: function () {
                        return listService.selectedCount > 1;
                    }
                },


                evenlySpaceAcross: {
                    name: 'Space evenly across',
                    onClick: function () {
                        alignmentController.spaceEvenly(listService.selected, constants.EVENLY_ACROSS)
                        alignmentController.spaceEvenly(listService.selected, constants.EVENLY_ACROSS)
                    },
                    isEnabled: function () {
                        return listService.selectedCount > 2;
                    }
                },
                evenlySpaceDown: {
                    name: 'Space evenly down',
                    onClick: function () {
                        alignmentController.spaceEvenly(listService.selected, constants.EVENLY_DOWN)
                        alignmentController.spaceEvenly(listService.selected, constants.EVENLY_DOWN)
                    },
                    isEnabled: function () {
                        return listService.selectedCount > 2;
                    }
                },

                moveToTopLayer: {
                    name: 'Move to top layer',
                    onClick: function () {
                        alignmentController.toTop(listService.selected);
                    },
                    isEnabled: function () {
                        const isFormOrLayout = listService._docType === constants.DOC_TYPE_FORM
                            ||  listService._docType === constants.DOC_TYPE_REPORT;
                        return isFormOrLayout || listService.selectedCount > 0;
                    }
                },
                moveToBottomLayer: {
                    name: 'Move to bottom layer',
                    onClick: function () {
                        alignmentController.toBottom(listService.selected);
                    },
                    isEnabled: function () {
                        const isFormOrLayout = listService._docType === constants.DOC_TYPE_FORM
                            ||  listService._docType === constants.DOC_TYPE_REPORT;
                        return isFormOrLayout || listService.selectedCount > 0;
                    }
                },
                groupToggle: {
                    name: 'Group / ungroup',
                    onClick: function () {
                        setTimeout(() => {
                            groupController.toggleGroup(listService.selected);
                        }, 0);
                    },
                    isEnabled: function () {
                        return listService.selectedCount > 0;
                    }
                },
                showAvailableBehaviors: {
                    name: 'Show active behaviors',
                    onClick: function (element) {
                        let objectId = '';
                        if (element[0].id === 'aPageSel') {
                            objectId = listService.currentPageId;
                        } else {
                            objectId = element[0].id;
                        }
                       //Validate the Instance behavior contains controls added
                       let reloadInstances = false;
                        let activeInstancesBehaviors = listService.getBehaviorInstanceByObject(objectId);
                        //loop and delete instances with no controls
                        activeInstancesBehaviors.map((beh)=> {                            
                            const object = listService.getBehaviorInstanceObjects(beh.get('id'));
                            if (!(object && object.size > 0)){
                                listService.destroyBehaviorInstance(beh.get('id'));
                                reloadInstances = true;
                            }                        
                        });
                        //we reload if we delete some instances
                        if (reloadInstances){
                            activeInstancesBehaviors = listService.getBehaviorInstanceByObject(objectId);
                        }
                        //we make sure we are passing the current name of the object TODO maybe update the names in the _behaviorInstanceList whenever change the name
                        activeInstancesBehaviors.map((beh)=> {                            
                              beh.set('owner',listService.getObjectName(objectId),{silent:true});                             
                         });

                        let items = [];

                        activeInstancesBehaviors.map((beh)=> {
                           console.log(beh);
                            let item = {
                                parent: listService.getParentNameOfObject(objectId),
                                owner: beh.get('owner'),
                                text: beh.get('text'),
                                id: beh.get('id')
                            }

                            items.push(item);
                        });

                        const alertView = new ShowBehaviorListModalView({model: new Model({items: items})});
                        alertView.render().then(selectedItemInModal => {
                            console.log('Selected Behavior', selectedItemInModal);
                        });


                    },
                    isEnabled: function (element) {
                        let objectId = '';
                        if (element[0].id === 'aPageSel') {
                            objectId = listService.currentPageId;
                        } else {
                            objectId = element[0].id;
                        }

                        let activeBehaviors = listService.getBehaviorInstanceByObject(objectId);
                        return activeBehaviors.size > 0;
                    }
                }
            }
        });
        $('.dropdown.bootstrapMenu').addClass('designer-context-menu');

        // Send click to PF page if ESC pressed.
        $(constants.CONTENT_ID).on('keyup',this.handleKeyUp.bind(this));

    } // <-- end construtor()

    handleKeyUp(ev) {
        //console.log(ev);
        if (ev.keyCode === constants.KEY_ESC) {
            //console.log('ESC key');
            $(constants.CONTENT_ID).trigger('click');
        }
    }

    get menu() {
        return this._menu
    }

    remove() {
        $(constants.CONTENT_ID).off('keyup', handleKeyUp);
        this._menu.destroy();
        super.remove();
    }
}

export default ContextMenuController;
